<template>
  <div class="edit-grupou">
    <h1>Editar Grupo</h1>
    
    <div class="alert alert-info" v-if="loading">Cargando grupo...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <form @submit.prevent="submitForm" class="mt-4 card p-4 bg-light" v-if="!loading && !error">
      <div class="mb-3">
        <label for="grupouCode" class="form-label">Cu00f3digo</label>
        <input 
          type="text" 
          class="form-control" 
          id="grupouCode" 
          v-model="grupou.GrupouCode" 
          disabled
        >
      </div>
      <div class="mb-3">
        <label for="grupouName" class="form-label">Nombre</label>
        <input 
          type="text" 
          class="form-control" 
          id="grupouName" 
          :value="grupou.GrupouName"
          @input="updateField('GrupouName', $event.target.value)"
          required
        >
      </div>
      <div class="mb-3 form-check">
        <input 
          type="checkbox" 
          class="form-check-input" 
          id="esActivo" 
          :checked="grupou.EsActivo"
          @change="updateField('EsActivo', $event.target.checked)"
        >
        <label class="form-check-label" for="esActivo">Activo</label>
      </div>
      <div class="d-flex gap-2">
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          <i v-else class="bi bi-save me-1"></i>
          Actualizar
        </button>
        <router-link to="/grupous" class="btn btn-secondary">
          <i class="bi bi-x-circle me-1"></i> Cancelar
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import EditGrupouViewController from './EditGrupouController.js';
import { handleResponse } from '../../utils/mgk-response-handler';

export default {
  name: 'EditGrupouView',
  props: ['code'],
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditGrupouViewController()
    }
  },
  computed: {
    grupou() {
      return this.controller.getGrupou();
    },
    loading() {
      return this.controller.isLoading();
    },
    saving() {
      return this.controller.isSaving();
    },
    error() {
      return this.controller.getCurrentError();
    }
  },
  created() {
    this.controller.initialize(this.code);
  },
  methods: {
    async submitForm() {
      if (!this.controller.validateForm()) {
        this.$alert.error('Por favor, complete todos los campos requeridos.');
        return;
      }

      try {
        const response = await this.controller.saveGrupou();
        handleResponse(response, 'Grupo actualizado correctamente.', 'Error al actualizar el grupo.');
        if (response.data.Number > 0) {
          this.$router.push('/grupos');
        }
      } catch (error) {
        this.$alert.error('Error al actualizar el grupo. Por favor, intente de nuevo.');
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    goBack() {
      this.$router.push('/grupous');
    }
  }
}
</script>

<style scoped>
.edit-grupou {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
